export default __webpack_public_path__ + "static/zap-ea692301e51cdb7d17a7c00f4e2e505d.svg";